<template>
  <el-row>
    <el-col
      :sm="{ span: 14, offset: 5 }"
      :md="{ span: 12, offset: 6 }"
      :lg="{ span: 12, offset: 6 }"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-header
        height="200px"
        class="app-header pt-15"
      >
        <Menu v-if="isLoggedIn" />
        <h3 class="app-header-title">
          {{ $t("menu.sign-up") }}
        </h3>
        <img
          src="@/assets/img/logo-white.png"
          alt="Tippie"
          width="100px"
          class="app-header-logo mt-30"
        >
      </el-header>
      <el-main>
        <el-form
          :model="signUpForm"
          :rules="getFormRules"
          ref="signUpForm"
          label-position="top"
          class="auth"
          :inline-message="true"
        >
          <el-form-item
            :label="$t('profile.first-name')"
            prop="name"
          >
            <el-input
              v-model="signUpForm.name"
              placeholder="Enter Your First Name"
            />
          </el-form-item>
          <el-form-item
            :label="$t('profile.last-name')"
            prop="name"
          >
            <el-input
              v-model="signUpForm.surName"
              placeholder="Enter Your Last Name"
            />
          </el-form-item>
          <el-form-item
            :label="$t('profile.phone')"
            prop="phone"
          >
            <vue-tel-input
              v-model="signUpForm.phone"
              @input="trimSpaces($event, 'phone')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('profile.email')"
            prop="email"
          >
            <el-input
              v-model="signUpForm.email"
              placeholder="Enter Your E-mail"
            />
          </el-form-item>
          <p class="password-decription">
            {{ $t("profile.password-desc") }}
          </p>
          <el-form-item
            style="margin-top: -10px;"
            :label="$t('profile.password')"
            prop="password"
          >
            <el-input
              v-model="signUpForm.password"
              placeholder="Enter your password"
              @input="trimSpaces($event, 'password')"
              show-password
            >
              <el-tooltip
                slot="append"
                :content="$t('auth.generate-password')"
                placement="top"
              >
                <el-button
                  @click="generatePassword"
                  icon="el-icon-refresh"
                />
              </el-tooltip>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('profile.re-password')"
            prop="repeatPassword"
          >
            <el-input
              type="password"
              v-model="signUpForm.repeatPassword"
              @input="trimSpaces($event, 'repeatPassword')"
              :placeholder="$t('profile.re-password')"
              show-password
            />
          </el-form-item>
          <el-form-item
            :label="$t('profile.notification-emails')"
            prop="sendPaymentEmail"
          >
            <el-radio-group v-model="signUpForm.sendEmailEnabled">
              <el-radio :label="'true'">
                {{ $t("yes") }}
              </el-radio>
              <el-radio :label="'false'">
                {{ $t("no") }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="isBusiness || isAdmin"
            :label="$t('profile.user-type.title')"
            prop="userType"
          >
            <el-checkbox-group v-model="signUpForm.userType">
              <el-checkbox label="employee">
                {{ $t("profile.user-type.types.employee") }}
              </el-checkbox>
              <el-checkbox
                v-if="isAdmin"
                label="business-representative"
              >
                {{ $t("profile.user-type.types.business") }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <p class="terms-text">
              {{ $t("auth.user-signup-terms-text") }}
              <a
                href="https://tippie.de/agb/"
                target="_blank"
              >
                {{ $t("auth.user-terms-link") }}
              </a>
            </p>
          </el-form-item>
          <el-form-item class="align-center mt-20 mb-20">
            <el-button
              type="primary"
              @click="submitForm('signUpForm')"
              class="primary-button"
            >
              {{ $t("form.next") }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import { Auth } from "@aws-amplify/auth";
import authHelpers from "@/plugins/auth-helpers";
import { usersAPI } from "@/shared/services/users.service";
import Menu from "../Menu/Menu";

export default {
  name: "SignUp",
  components: {
    Menu,
  },
  data: () => ({
    fullscreenLoading: false,
    isAdmin: false,
    isBusiness: false,
    isLoggedIn: false,
    signUpForm: {
      name: "",
      surName: "",
      phone: "",
      email: "",
      password: "",
      repeatPassword: "",
      userType: ["employee"],
      sendEmailEnabled: "false",
    },
  }),
  created() {
    Auth.currentAuthenticatedUser().then(() => {
      this.isLoggedIn = true;
    });
    authHelpers.isCurrentUserAdmin().then((response) => {
      this.isAdmin = response;
    });
    authHelpers.isCurrentUserBusiness().then((response) => {
      this.isBusiness = response;
    });
  },
  computed: {
    getFormRules: function() {
      const confirmPassValidator = (rule, value, callback) => {
        if (value !== this.signUpForm.password) {
          callback(
            new Error(
              this.$t("form.validation.dont-much", {
                field: this.$t("profile.password"),
              })
            )
          );
        } else {
          callback();
        }
      };
      return {
        name: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.first-name"),
            }),
            trigger: "blur",
          },
        ],
        surName: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.last-name"),
            }),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.phone"),
            }),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.password"),
            }),
            trigger: "blur",
          },
          {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[$&+,:;=?@#|'<>.^*()%!-]).{8,}$/,
            message: this.$t("profile.password-desc"),
          },
        ],
        repeatPassword: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.re-password"),
            }),
            trigger: "blur",
          },
          { validator: confirmPassValidator, trigger: "blur" },
        ],
        userType: [
          {
            required: true,
            message: this.$t("form.validation.required", {
              field: this.$t("profile.user-role"),
            }),
            trigger: "change",
          },
        ],
      };
    },
  },
  methods: {
    trimSpaces(value = "", field) {
      this.signUpForm[field] = value.replace(/\s/g, "");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.signUp();
        } else {
          return false;
        }
      });
    },
    async signUp() {
      this.fullscreenLoading = true;
      const phone = this.signUpForm.phone.replace(/[^\d.+]/g, "");
      Auth.signUp({
        username: phone,
        password: this.signUpForm.password,
        attributes: {
          email: this.signUpForm.email,
          phone_number: phone,
          name: this.signUpForm.name,
          family_name: this.signUpForm.surName,
          "custom:organization": this.$route.params.organization || "",
          "custom:roles": this.signUpForm.userType.toString(),
          "custom:onboarding": this.$route.params.organization
            ? "true"
            : "false",
          "custom:send_email_enabled": this.signUpForm.sendEmailEnabled,
        },
      })
        .then(async (cognitoUser) => {
          if (window.messageHandler) {
            cognitoUser.getSession((err, session) => {
              const message = {
                type: "login_completed",
                token: session.getAccessToken().getJwtToken(),
              };
              window.messageHandler.postMessage(JSON.stringify(message));
            });
          }
          if (this.$route.params.organization) {
            this.$axios
              .post("/api/v1/send-email", {
                to: process.env.VUE_APP_ADMIN_EMAIL,
                subject: "New user credentials",
                text: `Phone: ${this.signUpForm.phone} <br> Password: ${this.signUpForm.password}`,
              })
              .then(() => {
                this.fullScreenLoading = false;
                this.$router.push({ name: "User" });
              })
              .catch(() => {
                this.fullScreenLoading = false;
              });
          } else {
            const [error] = await usersAPI.updateUser(
              {
                email: this.signUpForm.email,
                phoneNumber: phone,
                password: this.signUpForm.password,
                name: this.signUpForm.name,
                familyName: this.signUpForm.surName,
              },
              cognitoUser.userSub
            );

            if (error) {
              this.fullscreenLoading = false;
              this.$message.error(this.$t("form.something-wrong"));
              return;
            }

            this.fullScreenLoading = false;
            this.$router.push({ name: "User" });
          }
        })
        .catch((error) => {
          this.fullscreenLoading = false;
          this.$message.error(error.message);
        });
    },
    generatePassword() {
      const allowed = {
        uppers: "QWERTYUIOPASDFGHJKLZXCVBNM",
        lowers: "qwertyuiopasdfghjklzxcvbnm",
        numbers: "1234567890",
        symbols: "!@#$%^&*",
      };

      const getRandomCharFromString = (str) =>
        str.charAt(Math.floor(Math.random() * str.length));
      const generatePassword = (length = 8) => {
        let pwd = "";
        pwd += getRandomCharFromString(allowed.uppers);
        pwd += getRandomCharFromString(allowed.lowers);
        pwd += getRandomCharFromString(allowed.numbers);
        pwd += getRandomCharFromString(allowed.symbols);
        for (let i = pwd.length; i < length; i++)
          pwd += getRandomCharFromString(Object.values(allowed).join(""));
        return pwd;
      };
      this.signUpForm.password = this.signUpForm.repeatPassword = generatePassword();
    },
  },
};
</script>

<style scoped lang="scss">
.password-decription {
  margin-top: 12px;
  margin-bottom: 10px;
  font-family: "Raleway Regular", serif;
  font-size: 14px;
}

.terms-text {
  margin-top: 20px;
  font-family: "Raleway Regular", serif;
  font-size: 14px;

  a {
    color: #ff8a00;
    text-decoration: underline;
  }
}
</style>
